// src/js/utils/focusTrap.js

const focusableElementsSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

// Vi använder en array som en "stack" för att hålla reda på öppna modaler
const trapStack = []; 
let currentTrap = null;

function handleKeyDown(event) {
    if (event.key !== 'Tab' || !currentTrap) return;

    if (event.shiftKey) { // Backwards tab
        if (document.activeElement === currentTrap.first) {
            event.preventDefault();
            currentTrap.last.focus();
        }
    } else { // Forwards tab
        if (document.activeElement === currentTrap.last) {
            event.preventDefault();
            currentTrap.first.focus();
        }
    }
}

// En hjälpfunktion som uppdaterar fällan till den översta modalen i stacken
function updateCurrentTrap() {
    if (trapStack.length === 0) {
        currentTrap = null;
        document.removeEventListener('keydown', handleKeyDown);
        return;
    }

    const modalElement = trapStack[trapStack.length - 1]; // Hämta den översta modalen
    const focusableElements = Array.from(modalElement.querySelectorAll(focusableElementsSelector));
    
    if (focusableElements.length > 0) {
        currentTrap = {
            first: focusableElements[0],
            last: focusableElements[focusableElements.length - 1]
        };
    } else {
        // Fallback om inga fokuserbara element finns, fällan låser till själva modalen
        currentTrap = { first: modalElement, last: modalElement }; 
    }
}

export function activateTrap(element) {
    // Om detta är den första modalen som öppnas, lägg på den globala lyssnaren
    if (trapStack.length === 0) {
        document.addEventListener('keydown', handleKeyDown);
    }
    // Lägg till den nya modalen överst i stacken
    trapStack.push(element);
    // Uppdatera fällan till att gälla den nya, översta modalen
    updateCurrentTrap();
}

export function deactivateTrap() {
    // Ta bort den översta modalen från stacken
    trapStack.pop();
    // Uppdatera fällan till att gälla den modal som nu ligger överst (om någon)
    updateCurrentTrap();
}